module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image14.d87f8185.jpg";